var exports = {};
// fixes an issue in std@0.80.0 (deno)
// interface ReadableStream<R> {
//   getIterator(): any
// }
Object.defineProperty(exports, "__esModule", {
  value: true
}); //# sourceMappingURL=types.js.map

export default exports;